import { makeStyles } from '@material-ui/core/styles';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';
import COLORS from 'shared/constants/colors';

const AccordionSummary = withStyles({
  root: {
    minHeight: 0,
    padding: 0,
    margin: 0,
    '&$expanded': {
      minHeight: 0,
    },
  },
  content: {
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: '0 16px',
    display: 'block',
    margin: '16px 0',
  },
})(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    border: '1px solid #d9d9d9',
    borderRadius: '3px',
  },
  heading: {
    fontSize: '14px',
    fontWeight: '700',
    color: COLORS.BLACK,
    textTransform: 'uppercase',
    padding: '0 16px',
  },

  accordion: {
    boxShadow: 'none',
    borderTop: '1px solid #d9d9d9;',
    // borderRadius: '0 !important',
    margin: '0 !important',
    '&:first-child': {
      borderTop: '0',
    },
    '&::before': {
      content: 'none',
    },
  },
}));

export { AccordionSummary, AccordionDetails, useStyles };
